import { BarMenu } from "./BarMenu.js";

/**
 * Class to implement the bar-menu manager
 * as a singleton, which can be instantiated
 * by any other extension as a dependency
 */
export class BarMenuManager {
    private static manager: BarMenuManager;
    private instances: BarMenu[] = [];

    /**
     * The private constructor
     * prevents direct instantiation
     */
    private constructor() {
        this.barMenus.forEach((barMenu) => {
            this.instances.push(new BarMenu(barMenu));
        });
    }

    /**
     * Method to instantiate all
     * bar-menus on the current page
     *
     * @param {boolean} [reset=false]
     * @returns {BarMenuManager}
     */
    public static use(reset: boolean = false): BarMenuManager {
        if (!BarMenuManager.manager || reset) {
            BarMenuManager.manager = new BarMenuManager();
        }
        return BarMenuManager.manager;
    }

    /**
     * Selects the bar-menus
     *
     * @returns {NodeListOf<HTMLElement>}
     */
    protected get barMenus(): NodeListOf<HTMLElement> {
        return document.querySelectorAll(
            `[scope="header-main-menu"][template="bar"]`,
        );
    }

    /**
     * Returns the number of instantiated bar-menus
     *
     * @returns {number}
     */
    public get length(): number {
        return this.instances.length;
    }
}
